import { IS_EMPTY, IS_NOT_EMPTY } from '../filter-conditions.js';
export const fileFilterConditions = [
    IS_EMPTY,
    IS_NOT_EMPTY,
];
//# sourceMappingURL=filters.js.map